import { Button } from '@hub/shared'
import { useTranslation } from 'react-i18next'

export default () => {
  const [t] = useTranslation('backToTop')

  return (
    <section className="back-to-top-button display-flex justify-content-center">
      <Button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        size="sm"
        color="transparent"
        textColor="var(--primary_color)"
        inverted
        rounded
      >
        <i className="fa-solid fa-triangle"></i> {t('backToTop')}
      </Button>
    </section>
  )
}
